import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Marketing } from './marketing.list';

export const routes: Routes = [
    //  { path: 'branch/:id', loadChildren: '../branch/branch.module#BranchModule' },
    {
        path: 'productedit/:id',
        data: { reuse: false },
        loadChildren: () =>
            import('../productdetail/productdetail.module').then(
                (mod) => mod.ProductDetailModule
            ),
    },
    { path: 'page/marketing', component: Marketing },
    { path: '', redirectTo: 'page/marketing', pathMatch: 'full' },
];

export const MARKETING_ROUTER_PROVIDERS = RouterModule.forRoot(routes);
